<script setup>
import { ref } from 'vue';
import Base from './FileUpload/Base.vue';
import Media from './FileUpload/Media.vue';

const parent = ref();

defineProps({
    hidePicker: {
        default: false,
        type: Boolean,
    }
});
</script>

<template>
    <Base ref="parent">
        <div v-if="parent" class="w-full min-w-0 overflow-auto flex gap-2">
            <template v-for="file in parent.files" :key="file.id">
                <div class="shrink-0 relative">
                    <Media :file="file" />

                    <div class="absolute top-1 right-1">
                        <app-icon-button
                            :disabled="parent.field.disabled"
                            @click="parent.removeFile(file.id)"
                            icon="cancel-bold"
                            xs
                            color="black"
                            button-style="filled"
                            aria-label="Remove file" />
                    </div>
                </div>
            </template>

            <button
                v-if="(!hidePicker || parent.field.state?.length > 0) && (parent.field.props.multiple || parent.field.state?.length < 1)"
                class="size-20 flex items-center justify-center border border-dashed
                border-white-foreground/20 text-white-foreground/80 rounded-md shrink-0 disabled:opacity-35"
                type="button"
                :disabled="parent.field.disabled || (parent.field.props.multiple && parent.remainingSlots < 1)"
                :title="parent.field.props.multiple && parent.remainingSlots < 1 ? `You can only upload a maximum of ${parent.field.props.maxFiles}` : undefined"
                @click="parent.selectFile()"
                >
                <icon-plus-circle class="size-7" />
            </button>
        </div>
    </Base>
</template>
